import * as constants from './constants';

export const initialStatusesState = {
  statusesReferencelist: [], // справочник статусов
  statusesReferenceServiceId: undefined, // ServiceId - по которому формировался statusesReferencelist
  statusesReferenceSourceRefValueId: undefined, // SourceRefValueId - по которому формировался statusesReferencelist
  loadingStatusesReferencelist: false, // отметка процесса загрузки справочника
  error: undefined,
};

const statusesReducer = (state = initialStatusesState, action) => {
  switch (action.type) {
    case constants.RESET_ERROR:
    case constants.FETCH_STATUS_REFERENCE:
    case constants.FETCH_STATUS_REFERENCE_FAIL:
    case constants.FETCH_STATUS_REFERENCE_SUCCESS:
    case constants.CREATE_STATUS_REFERENCE_SUCCESS:
    case constants.CREATE_STATUS_REFERENCE_FAIL:
    case constants.UPDATE_STATUS_REFERENCE_SUCCESS:
    case constants.UPDATE_STATUS_REFERENCE_FAIL:
    case constants.DELETE_STATUS_REFERENCE_SUCCESS:
    case constants.DELETE_STATUS_REFERENCE_FAIL:
    case constants.CLEAR_STATUS_REFERENCE:
      return { ...state, ...action.payload };
    default:
      return state;
  }
};

export default statusesReducer;
